const CmsPage = () =>
  import(
    /* webpackChunkName: "cms-page" */ '@/pages/cms/content/page/index.vue'
  )
const CreateCmsPage = () =>
  import(
    /* webpackChunkName: "cms-page" */ '@/pages/cms/content/page/create.vue'
  )
const EditCmsPage = () =>
  import(/* webpackChunkName: "cms-page" */ '@/pages/cms/content/page/edit.vue')

export default {
  path: 'page',
  meta: {
    label: 'page',
    auth: 'page'
  },
  component: {
    name: 'Page',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CmsPageReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: CmsPage
    },
    {
      name: 'CmsCreatePage',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCmsPage
    },
    {
      name: 'CmsEditPage',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCmsPage,
      props: true
    }
  ]
}
